import { Component, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../services/auth.service';
import { SessionService } from '../../services/session/session.service';
import { TokenStorageService } from '../../services/storage/token-storage.service';
import { UserService } from '../../services/user.service';
import { MasterAccountsComponent } from '../master-accounts/master-accounts.component';

@Component({
    selector: 'app-create-master-account',
    templateUrl: './create-master-account.component.html',
    styleUrls: ['./create-master-account.component.css'],
    standalone: false
})
export class CreateMasterAccountComponent implements OnInit {
  createMasterAccClicked: boolean = false;
  masterAccForm: FormGroup = new FormGroup({});
  isSuccessful: boolean = false;
  isSignUpFailed: boolean = true;
  errorMessage: string = '';
  loading: boolean = false;
  initialLoading: boolean = false;
  isLoggedIn: boolean = false;
  role: string = '';
  user: any;
  countries: any[] = [];
  institutions: any;
  sortedCountries: any;
  isBrokerSignup: boolean = false;
  registrationSuccess: boolean = false;
  requestId: number = 0;


  banks: any;
  isDone: boolean = false;

  masterAccountCreated:boolean=false;
  env:any;

  @ViewChild(MasterAccountsComponent) MasterAccountsComponent!: MasterAccountsComponent;
  con: any;
  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private toastr: ToastrService,
    private tokenStorage: TokenStorageService,
    private userService: UserService,
    private router: Router,
    private sessionStorageService: SessionService,
  ) { }

  ngOnInit(): void {
    this.initializeInstitutionForm();

    if (this.tokenStorage.getToken()) {

      this.isLoggedIn = true;
      this.user = this.tokenStorage.getUser().username;
      this.role = this.user.role;
      this.env = this.tokenStorage.getUserEnv();
    }

    this.countryList()
    this.getCountryCode()
  }
  checkDone(){
    this.isDone=this.MasterAccountsComponent.isAllDone;
  }
  countryList() {
    this.initialLoading = true;
    this.userService.getCountryList().subscribe({
      next: (data) => {
        if (data.status == 'SUCCESS') {
          this.countries = data.countryList.sort((a: any, b: any) =>
            a.countryName > b.countryName ? 1 : -1
          );
        } else {
          this.errorMessage = data.reason;
          this.toastr.error(
            this.errorMessage,
            'Error getting country list'
          );
        }
        this.initialLoading = false;
      },
      error: (err) => {
        this.errorMessage = err.error.message;
        this.toastr.error(
          this.errorMessage,
          'Error getting country list'
        );
        this.initialLoading = false;
      },
    });
  }
  getCountryCode(){
    this.userService.getIp().subscribe((ip) => {
      this.userService.getCountryCode(ip).subscribe((code) => {
        const contryCode = JSON.parse(code).country_calling_code;
        this.masterAccForm.controls['masterAccContactNoMobile'].setValue(contryCode+"-00000000");
        this.con = contryCode;

      });

    });
  }
  initializeInstitutionForm(): void {
    this.masterAccForm = this.formBuilder.group({
      masterAccLastName: ['', [Validators.required]],
      masterAccContactNoMobile: ['', [Validators.required]],
      contactNumber: ['', [Validators.required]],
      masterAccEmail: ['', [Validators.required, Validators.email]],
      masterAccProfession: ['', [Validators.required]],
      masterAccCountryID: ['', [Validators.required]],
      masterAccNationality: ['', [Validators.required]],
    });
  }

  createMasterAccount() {
    this.createMasterAccClicked = true;
    this.loading = true;
    if (this.masterAccForm.invalid) {
      this.toastr.error('Invalid from data', 'Master account creation failed');
      return;
    }

    const {
      masterAccLastName,
      masterAccContactNoMobile,
      contactNumber,
      masterAccEmail,
      masterAccProfession,
      masterAccCountryID,
      masterAccNationality
    } = this.masterAccForm.value;
    const instCode = this.sessionStorageService.getItem('newInstCode')
    this.userService.createMasterAccount(instCode, masterAccLastName, this.con+'-'+contactNumber, masterAccEmail, masterAccProfession, masterAccCountryID, masterAccNationality, 1)
      .subscribe({
        next: (data) => {
          if (data.status == 'SUCCESS') {
            this.toastr.success(data.reason, 'Success');
            this.masterAccForm.get('masterAccLastName')?.disable();
            this.masterAccForm.get('masterAccContactNoMobile')?.disable();
            this.masterAccForm.get('contactNumber')?.disable();
            this.masterAccForm.get('masterAccEmail')?.disable();
            this.masterAccForm.get('masterAccProfession')?.disable();
            this.masterAccForm.get('masterAccCountryID')?.disable();
            this.masterAccForm.get('masterAccNationality')?.disable();
            this.MasterAccountsComponent.show(data.customerId, data.customerNumber)
            this.masterAccountCreated=true;
          } else {
            this.errorMessage = data.reason;
            this.toastr.error(
              this.errorMessage,
              'Unable to create master account'
            );
          }
          this.loading = false;
        },
        error: (err) => {
          this.errorMessage = err.error.message;
          this.toastr.error(
            this.errorMessage,
            'Unable to create master account'
          );
          this.loading = false;
        },
      });
  }


  reloadPage(): void {
    window.location.reload();
  }

  get formInstControl(): { [key: string]: AbstractControl } {
    return this.masterAccForm.controls;
  }

}
